import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.ClinicaMedicaServiceProxy,
        ApiServiceProxies.ProfissionalSaudeServiceProxy,
        ApiServiceProxies.RegistroClasseServiceServiceProxy,
        ApiServiceProxies.PacienteServiceProxy,
        ApiServiceProxies.ProntuarioMedicoServiceProxy,
        ApiServiceProxies.ArquivoServiceProxy,
        ApiServiceProxies.AssinaturaServiceProxy,
        ApiServiceProxies.EnumServiceProxy,
        ApiServiceProxies.FuncionarioServiceProxy,
        ApiServiceProxies.PressaoArterialServiceProxy,
        ApiServiceProxies.BatimentosCardiacosServiceProxy,
        ApiServiceProxies.RegistroAcessoProntuarioServiceProxy,
        ApiServiceProxies.GlicoseServiceProxy,
        ApiServiceProxies.FrequenciaRespiratoriaServiceProxy,
        ApiServiceProxies.QualidadeSonoServiceProxy,
        ApiServiceProxies.TemperaturaServiceProxy,
        ApiServiceProxies.HumorServiceProxy,
        ApiServiceProxies.AlturaServiceProxy,
        ApiServiceProxies.OximetriaServiceProxy,
        ApiServiceProxies.PesoServiceProxy,
        ApiServiceProxies.ImcServiceProxy,
        ApiServiceProxies.DorArticularServiceProxy,
        ApiServiceProxies.PacienteClinicaMedicaServiceProxy,
        ApiServiceProxies.ProfissionalSaudePacienteServiceProxy,
        ApiServiceProxies.PlanoServiceProxy,
        ApiServiceProxies.ConvenioServiceProxy,
        ApiServiceProxies.EquipeClinicaServiceProxy,
        ApiServiceProxies.ChatServiceServiceProxy,
        ApiServiceProxies.ChatNotificacaoServiceProxy,
        ApiServiceProxies.CidServiceProxy,
        ApiServiceProxies.MedicamentoTissServiceProxy,
        ApiServiceProxies.MedicamentoSigtapServiceProxy,
        ApiServiceProxies.ProcedimentoSigtapServiceProxy,
        ApiServiceProxies.ProcedimentoTussServiceProxy,
        ApiServiceProxies.AutoCompleteServiceProxy,
        ApiServiceProxies.GrupoMonitoramentoServiceProxy,
        ApiServiceProxies.PrescricaoServiceProxy,      
        ApiServiceProxies.ConsultaServiceProxy,
        ApiServiceProxies.EventoServiceProxy,
        ApiServiceProxies.AgendaServiceProxy,
        ApiServiceProxies.ClinicaMedicaPacienteVipServiceProxy,
        ApiServiceProxies.AlergiaServiceProxy,
        ApiServiceProxies.PacienteAlergiaServiceProxy,
        ApiServiceProxies.CustoAdicionalMensalServiceProxy,
        ApiServiceProxies.ProfissionalSaudeClinicaMedicaServiceProxy,
        ApiServiceProxies.ProfissionalSaudeConvenioServiceProxy,
        ApiServiceProxies.ClinicaMedicaConvenioServiceProxy,
        ApiServiceProxies.PacienteConvenioServiceProxy,
        ApiServiceProxies.RelatorioServiceProxy,
        ApiServiceProxies.AdministrativoServiceProxy,
        ApiServiceProxies.MotorizacaoServiceServiceProxy,
        ApiServiceProxies.TokenNotificationServiceProxy,
        ApiServiceProxies.NotificacaoServiceProxy,
        ApiServiceProxies.RegistroRespostaPacienteClinicaServiceProxy,
        
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
